import { render, staticRenderFns } from "./epms3020.vue?vue&type=template&id=455f84fe&scoped=true"
import script from "./epms3020.vue?vue&type=script&lang=js"
export * from "./epms3020.vue?vue&type=script&lang=js"
import style0 from "./epms3020.vue?vue&type=style&index=0&id=455f84fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455f84fe",
  null
  
)

export default component.exports